import { render, staticRenderFns } from "./s3VideoList.vue?vue&type=template&id=2a241870"
import script from "./s3VideoList.vue?vue&type=script&lang=js"
export * from "./s3VideoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports